import { call, put, takeLatest } from 'redux-saga/effects';
import handleException from '../services/handleException';
import { convertName } from '../utils/orders';
import { CONVERT_NAME, CONVERT_NAME_FAILS, CONVERT_NAME_SUCCESS } from './../actions/addOrder';
import { CONVERT_NAME_EDIT_ORDER, CONVERT_NAME_EDIT_ORDER_FAILS, CONVERT_NAME_EDIT_ORDER_SUCCESS } from './../actions/editOrder';

export function* convertNameSaga() {
    yield takeLatest(CONVERT_NAME, convertNameHandle)
}

function* convertNameHandle(action) {
    try {
        const response = yield call(convertName, action.payload)

        if (response.data.code === 10001) {
            yield put({ type: CONVERT_NAME_SUCCESS, payload: response })
        } else {
            yield put({ type: CONVERT_NAME_FAILS, payload: response })
            handleException(response)
        }
    } catch (error) {
        yield put({ type: CONVERT_NAME_FAILS, payload: error })
        handleException(error)
    }
}

export function* convertNameEditOrderSaga() {
    yield takeLatest(CONVERT_NAME_EDIT_ORDER, convertNameEditOrderHandle)
}

function* convertNameEditOrderHandle(action) {
    try {
        const response = yield call(convertName, action.payload)

        if (response.data.code === 10001) {
            yield put({ type: CONVERT_NAME_EDIT_ORDER_SUCCESS, payload: response })
        } else {
            yield put({ type: CONVERT_NAME_EDIT_ORDER_FAILS, payload: response })
            handleException(response)
        }
    } catch (error) {
        yield put({ type: CONVERT_NAME_EDIT_ORDER_FAILS, payload: error })
        handleException(error)
    }
}



// WEBPACK FOOTER //
// ./src/sagas/convertNameSaga.js